import z from 'zod';
import { MANDATORY_FIELD } from '../../config/zodConfig';
import zod from 'zod';

const TimeSlotSchema = z
  .object({
    start: z.string().nullable(), // "HH:mm" vindo do input
    end: z.string().nullable(),
    type: z.enum(['enter', 'exit']).optional(),
    isEnter: z.boolean().optional(),
    isExit: z.boolean().optional(),
  })
  .refine((s) => !(s.isEnter && s.isExit), {
    message: 'Slot não pode ser Entrada e Saída ao mesmo tempo.',
  });

export const DailyScheduleSchema = z.object({
  weekday: z.string().min(1, MANDATORY_FIELD), // você pode usar z.enum(['Monday', ...]) se quiser validar os dias
  timeSlots: z.array(TimeSlotSchema), // <-- removido o `.min(1)`
});

export const SchoolShiftFormSchema = z.object({
  id: z.number().optional(),
  name: z.string().min(1, MANDATORY_FIELD),
  weeklySchedule: z.array(DailyScheduleSchema).min(1, MANDATORY_FIELD),
  deviceIds: zod.array(zod.number()).min(1, MANDATORY_FIELD),
});
